//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { LocationAddressInputItem } from './LocationAddressInputItem';
import { EventColorEnum, EventLocationIcon } from './Enums';

export class EventLocationInputItem extends ItemBase {
    Address: LocationAddressInputItem | null = null;
    Color: EventColorEnum = EventColorEnum.Beach;
    Icon: EventLocationIcon = EventLocationIcon.None;
    Name: string | null = null;
    Description: string | null = null;

    constructor(initializer?: Partial<EventLocationInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "EventLocationInputItem";
}
